import { AppBar, Button, LinearProgress, Toolbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import SimpleBar from 'simplebar-react';
import { Flex } from '@/components/UIKit/Grid';
import { ROLE } from '@/modules/User';
import useStyles from './style';

function Menu({ load, olimpic, user }) {
  const { menuContainer, menuNav, border, scroll, grad, preGrad } = useStyles();
  const history = useHistory();

  const isAdmin = user.role === ROLE.ADMIN || user.role === 5;

  const navItems = useMemo(
    () =>
      [
        {
          label: 'PROFILE_TITLE',
          to: '/profile',
          visible: true,
        },
        {
          label: 'DELEGATES',
          to: '/delegates',
          visible: isAdmin,
        },
        {
          label: 'OLIMPIC_TITLE',
          to: '/olimpic/about',
          visible: true,
        },
        {
          label: 'PUBLIC_RATING',
          to: '/olimpic/rating',
          visible: olimpic.show_rating || isAdmin,
        },
        {
          label: 'PERSONAL_RATING',
          to: '/olimpic/stats',
          visible: true,
        },
        {
          label: 'RESULTS',
          to: '/olimpic/ranking',
          visible: olimpic.show_results || isAdmin,
        },
        {
          label: 'PARTICIPANTS',
          to: '/olimpic/participants',
          visible: ROLE.SCHOOL === user.role || isAdmin,
        },
        {
          label: 'DIPLOMA',
          to: '/olimpic/diplomas',
          visible: olimpic.show_diploms || isAdmin,
        },
      ].filter(item => item.visible),
    [user, olimpic]
  );

  return (
    <AppBar component="nav" color="" className={menuContainer}>
      <SimpleBar className={scroll}>
        <Toolbar className={menuNav}>
          <Flex justifySelf="flex-end">
            {navItems.map(({ label, to }) => (
              <Button
                color="primary"
                key={label}
                onClick={() => history.push(to)}
              >
                <FormattedMessage id={label} defaultMessage={label} />
              </Button>
            ))}
          </Flex>
        </Toolbar>
      </SimpleBar>
      <div className={preGrad}>
        <div className={grad} />
        <Button color="primary" onClick={() => history.push('/logout')}>
          <FormattedMessage id="sidebar.logout" defaultMessage="Logout" />
        </Button>
      </div>
      <LinearProgress
        className={border}
        {...(load ? {} : { variant: 'determinate', value: 100 })}
      />
    </AppBar>
  );
}

Menu.propTypes = {
  load: PropTypes.bool.isRequired,
  olimpic: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateTopProps = state => ({
  load: state.requests.load,
  olimpic: state.olimpic.sama || {},
  user: state.user,
});

export default connect(mapStateTopProps)(Menu);
